import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CheckIcon from '@mui/icons-material/Check';
import CancelIcon from '@mui/icons-material/Cancel';

const YesNoDialog = (props) => {
   return (
      <Dialog
         open={props.open}
         onClose={props.handleDismiss}
         aria-labelledby="yes-no-dialog-title"
         aria-describedby="yes-no-dialog-description"
      >
         <DialogTitle id="yes-no-dialog-title">
            {props.title}
         </DialogTitle>
         <DialogContent>
            <DialogContentText id="yes-no-dialog-description">
               {props.description}
            </DialogContentText>
         </DialogContent>
         <DialogActions>
            <Button variant="outlined" startIcon={<CancelIcon />} onClick={props.handleDismiss}>{props.dismissButtonLabel}</Button>
            <Button variant="contained" startIcon={<CheckIcon />} onClick={props.handleAffirm} autoFocus>{props.affirmButtonLabel}</Button>
         </DialogActions>
      </Dialog>
   );
};

YesNoDialog.propTypes = {
   open: PropTypes.bool.isRequired,
   title: PropTypes.string.isRequired,
   description: PropTypes.string.isRequired,
   dismissButtonLabel: PropTypes.string.isRequired,
   affirmButtonLabel: PropTypes.string.isRequired,
   handleDismiss: PropTypes.func.isRequired,
   handleAffirm: PropTypes.func.isRequired,
};

export default YesNoDialog;
